import { render } from "./section-goods-category.vue?vue&type=template&id=6fe0346a&scoped=true&ts=true"
import script from "./section-goods-category.vue?vue&type=script&lang=ts"
export * from "./section-goods-category.vue?vue&type=script&lang=ts"

import "./section-goods-category.vue?vue&type=style&index=0&id=6fe0346a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe0346a"]])

export default __exports__